import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const appStoreUrl = "https://apps.apple.com/ng/app/nisa-care/id6767461961";
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.project.nisacare";

  const testimonials = [
    {
      id: 1,
      name: 'Aaliyah',
      image: '/images/avater.png',
      text: 'Finally a safe space where i can talk about cramps and my prayer schedule without feeling awkward. This app has changed how i view my monthly cycle entirely.'
    },
    {
      id: 2,
      name: 'Fatima',
      image: '/images/avater.png',
      text: 'This app understands the unique challenges Muslim women face. It has helped me balance my spiritual practices with my cycle in a way that feels natural and empowering.'
    },
    {
      id: 3,
      name: 'Zainab',
      image: '/images/avater.png',
      text: 'I love how this app combines faith with wellness. The reminders and insights are exactly what I needed to feel more connected to both my body and my practice.'
    },
    {
      id: 4,
      name: 'Aisha',
      image: '/images/avater.png',
      text: 'The community support here is incredible. I never knew how much I needed this until I found it. Thank you for creating such a safe and welcoming space.'
    },
    {
      id: 5,
      name: 'Mariam',
      image: '/images/avater.png',
      text: 'Tracking my cycle while staying true to my faith has never been easier. This app respects my values and helps me stay healthy at the same time.'
    }
  ];

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  // Calculate position class for each testimonial based on active index
  const getPositionClass = (testimonialIndex) => {
    const totalSlides = testimonials.length;
    let offset = testimonialIndex - activeIndex;
    
    // Normalize offset to be between -2 and 2
    if (offset > 2) offset -= totalSlides;
    if (offset < -2) offset += totalSlides;
    
    if (offset === 0) return 'active';
    if (offset === -1) return 'left-1';
    if (offset === -2) return 'left-2';
    if (offset === 1) return 'right-1';
    if (offset === 2) return 'right-2';
    return 'hidden';
  };

  return (
    <section id="community" className="testimonials-section">
      <Container>
        <h2 className="testimonials-title text-center">Voices from the Circle</h2>
      </Container>

      {/* CAROUSEL WITH BUTTONS */}
      <div className="testimonials-carousel-wrapper">
        <Container className="position-relative">
          {/* LEFT BUTTON */}
          <button 
            className="carousel-nav-btn carousel-nav-left"
            onClick={handlePrev}
            aria-label="Previous testimonial"
          >
            <BsChevronLeft size={24} />
          </button>

          {/* SLIDER - Render ALL testimonials */}
          <div className="testimonials-slider">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id}
                className={`testimonial-slide ${getPositionClass(index)}`}
              >
                <div className="testimonial-content">
                  <div className="testimonial-avatar">
                    <img src={testimonial.image} alt={testimonial.name} />
                  </div>
                  <h3 className="testimonial-name">{testimonial.name}</h3>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT BUTTON */}
          <button 
            className="carousel-nav-btn carousel-nav-right"
            onClick={handleNext}
            aria-label="Next testimonial"
          >
            <BsChevronRight size={24} />
          </button>
        </Container>
      </div>

      <Container>
        <div className="testimonials-cta text-center">
<div class="testimonials-download-buttons">
  <a 
    href="https://apps.apple.com/ng/app/nisa-care/id6767461961" 
    target="_blank" 
    rel="noopener noreferrer" 
    class="app-store-badge-small"
    aria-label="Download on the App Store"
  >
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
    </svg>
    <span>
      <small>Download on the</small>
      <strong>App Store</strong>
    </span>
  </a>
  <a 
    href="https://play.google.com/store/apps/details?id=com.project.nisacare" 
    target="_blank" 
    rel="noopener noreferrer" 
    class="play-store-badge-small"
    aria-label="Get it on Google Play"
  >
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.222 9.374c1.037-.61 1.037-2.137 0-2.748L11.528 5.04 8.32 8l3.207 2.96zm-3.595 2.116L7.583 8.68 1.03 14.73c.201 1.029 1.36 1.61 2.303 1.055zM1 13.396V2.603L6.846 8zM1.03 1.27l6.553 6.05 3.044-2.81L3.333.215C2.39-.341 1.231.24 1.03 1.27"></path>
    </svg>
    <span>
      <small>Get it on</small>
      <strong>Google Play</strong>
    </span>
  </a>
</div>
        </div>
      </Container>
    </section>
  );
};

export default Testimonials;